module.exports = __webpack_public_path__ + "img/banner.ac75e053.jpg";